export function parseIntEnv(
  value: string | undefined,
  fallback: number,
  min = 0,
  max?: number,
): number {
  const parsed = Number.parseInt(value ?? "", 10);
  if (!Number.isFinite(parsed)) return fallback;
  const clamped = parsed < min ? fallback : parsed;
  return max !== undefined ? Math.min(max, clamped) : clamped;
}

export function parseSampleRateEnv(value: string | undefined): 16000 | 24000 | null {
  const parsed = Number.parseInt(value ?? "", 10);
  return parsed === 16000 || parsed === 24000 ? parsed : null;
}

export function parseBooleanEnv(raw: string | undefined, fallback: boolean): boolean {
  const normalized = (raw ?? "").trim().toLowerCase();
  if (!normalized) return fallback;
  if (normalized === "1" || normalized === "true" || normalized === "yes" || normalized === "on")
    return true;
  if (normalized === "0" || normalized === "false" || normalized === "no" || normalized === "off")
    return false;
  return fallback;
}
